<template>
    <div id="print-stylesheet">
        <nav id="from-print">
            <div>
                <img src="@/assets/images/back-arrow.svg" alt="Go back">
            </div>
        </nav>
        <div id="print-view">
            <table>
                <tr valign="top">
                    <td width="50%">
                        <div class="col1">
                            <div class="header">
                                <figure class="logo"><img src="@/assets/images/Simpas_Applied_Solutions.svg" alt="Simpas Applied Solutions"></figure>
                                <h1>SIMPAS-applied Solutions</h1>
                                <h2><span>Farmer Benefit Tool</span></h2>
                                <p>See the value in prescriptively applying up to 3 products in 1 pass with our helpful&nbsp;calculator.</p>
                            </div>
                        </div>
                    </td>
                    <td width="50%">
                        <div class="col2">
                            <div class="print-input">
                                <h2>Input</h2>

                                <ul class="table-list">
                                    <li><strong>Total Farm Size Acres</strong> <span id="printNumAcres">2,000</span></li>
                                    <li class="green"><strong id="printNeed1Label">Nematode Control Problem Area</strong> <span id="printNeed1Pcg">35%</span></li>
                                    <li class="yellow"><strong id="printNeed2Label">Corn Rootworm Mgmt. Area</strong> <span id="printNeed2Pcg">35%</span></li>
                                    <li class="blue"><strong id="printNeed3Label">Micronutrient Deficiency Area</strong> <span id="printNeed3Pcg">25%</span></li>
                                    <!--<li><strong>Agronomist Prescription Fee</strong> <span id="printFee">$1.00</span></li>-->
                                    <li><strong>Current Price of <span id="printCropLabel">Corn</span></strong> <span id="printPrice">$4.50 /Bushel</span></li>
                                </ul>
                            </div>
                        </div>
                    </td>
                </tr>
                <tr valign="top">
                    <td class="t-prescriptive">
                        <div id="place-pa">
                        <h2>Prescriptive <span>Application</span></h2>
                        <div id="place-pa-data"></div>
                        </div>
                    </td>
                    <td class="t-whole">
                        <div id="place-npa">
                        <h2>Whole Field <span>Application</span></h2>
                        <div id="place-npa-data"></div>
                        </div>
                    </td>
                </tr>
                <tr class="row-footer">
                    <td colspan="2">
                        <footer>
                            <Footer :copyright="`&copy;${currentDate} AMVAC Chemical Corporation. All Rights Reserved.`"/>
                        </footer>
                    </td>
                </tr>
            </table>
        </div>
    </div>
</template>
<script>

import { defineAsyncComponent } from 'vue'
const Footer = defineAsyncComponent(() =>
    import ('@/components/Footer.vue'))

export default {
    name: 'Print',
    components: {
        Footer
    },
    computed: {
        currentDate() {
            return (new Date()).getFullYear();
        }
    },
    mounted: function() {
        setTimeout(function(){
            const fromprint = document.getElementById("from-print");
            fromprint.addEventListener('click', function (pv) {
                document.querySelector('html').classList.remove('print');
                document.querySelector('#app').classList.remove('show-print-view');
                pv.preventDefault();
            }, false);

            window.addEventListener('afterprint', function() {
                this.document.body.style.zoom = "normal"
            });
        }, 10);
    }
}
</script>
<style lang="sass">
@import ../assets/sass/includes/variables

#print-view
    margin: 0 auto
    max-width: 1000px
    display: none

nav#from-print
    display: none
.show-print-view
    padding-top: 2rem
    background-color: #ccc
    main, nav
        display: none
    nav#from-print
        display: block
    #print-view
        figure.logo img
            width: 140px
        background-color: #fff
        display: block
        box-shadow: 5px 5px rgba(#000, .1)
table
    .header
        padding: 0
    td
        padding: 2rem 1rem
    h2
        font-family: $font-bold
        font-size: 2rem
        margin-bottom: 1rem
        span
            display: block
            font-family: $font-bold
            font-size: 1.2rem
    p
        font-size: 1.2rem
#place-pa, #place-npa
    h1
        font-size: 2rem
    h2
        font-size: 1.6rem
    p
        padding: 0 1rem 0 0
    .col2 h2
        font-family: $font-bold
        margin: 3rem 0 2rem 0
    .btn
        display: none
    .details
        h3
            border-bottom: none
            border-top: 1px solid $grey
        p
            font-size: 1rem
            strong
                font-family: Gilroy-Black, Avenir, Helvetica, Arial, sans-serif
    .result-fields
        margin-bottom: 1rem
    .application-results-header
        .label 
            font-size: 1.2rem
            font-family: Gilroy-Black, Avenir, Helvetica, Arial, sans-serif
        .result-field
            border: 1px solid $grey
            padding: .5rem
            font-size: 1.3rem
            max-width: 200px
            margin: 0.5rem 0 1.5rem
.table-list
    margin: 0
    padding: 0
    list-style: none
    overflow: hidden
    li
        margin: 0 0 .5rem 0
        display: flex
        border-bottom: 1px solid #ccc
        padding: 0 0 .5rem 0
    strong
        width: 300px
        color: $black
        font-weight: normal
        font-family: $font-bold
    span
        display: inline-block
        font-size: 1.4rem

    .green
        color: $green

    .yellow
        color: $brown

    .blue
        color: $blue


.print
    overflow: visible
    body
        background-image: none
    #app
        background-color: transparent
    #print-view
        box-shadow: none


.show-print-view, .print
    .header h1
        +breakpoint($desk-lg)
            font-size: 2.3rem
    .header p
        margin-bottom: 0
    .info-bubble-yieldIncrease, .info-bubble-np_yieldIncrease
        display: none
    .footer
        padding: 0.5rem 2rem 0
    .row-footer td
        padding: 0
    table td
        padding-bottom: 1.5rem
    .t-prescriptive, .t-whole
        padding-bottom: 0
        padding-top: 0
    .result-field-headers .result-field
        padding-top: 0
    label strong
        margin: 0
    #place-pa .application-results-header .result-field, #place-npa .application-results-header .result-field
        width: max-content
    .result-field-headers .result-field, .result-fields .result-field
        font-size: 0.8rem

@media print
    .header h1
        font-size: 1.7rem
    .header p
        font-size: 0.9rem
    .print-input h2
        font-size: 1.3rem
    .table-list strong
        font-size: 0.95rem
    #place-pa h2, #place-npa h2
        font-size: 1.3rem
    #place-pa .details p, #place-npa .details p
        margin-bottom: 0.2rem
    #print-stylesheet label strong
        display: block
        width: 100%
        margin: 0
        padding-right: 0
        padding-bottom: 0.2rem
        font-size: 0.85rem
    #place-pa .application-results-header .label, #place-npa .application-results-header .label
        font-size: 1rem
    #place-pa .application-results-header .result-field, #place-npa .application-results-header .result-field
        font-size: 1rem
        margin: 0
    .result-fields .result-field, input, select
        font-size: 0.75rem
    input
        padding: 0.3rem 0.2rem
        margin: 0
        height: 1.7rem
        line-height: 1.7rem
    #print-stylesheet #p_need1, #print-stylesheet #p_need2, #print-stylesheet #p_need3,
    #print-stylesheet #np_need1, #print-stylesheet #np_need2, #print-stylesheet #np_need3
        font-size: 13px
        padding: 0
        margin: 0
        line-height: 1.1
</style>